import ring from "./ring.wav";
import chatRing from "./chat-ring.mp3";
import digitalRing from "./digital-ring.mp3";
import dangRing from "./dang.mp3";
import phonenewringtone from "./phonenewringtone.mp3";
import ringbacknewtone from "./ringbacknewtone.mp3";
import { RING_TYPES } from "../../constants/constants";

interface PlayerOptions {
  type: string;
  loop?: boolean;
}

class Player {
  private audio: HTMLAudioElement | null = null;
  private type: string;
  private loop: boolean;
  private soundSource: string;

  constructor(options: PlayerOptions) {
    this.type = options.type;
    this.loop = options.loop || false;

    // Determine sound source based on type
    switch (options.type) {
      case RING_TYPES.CALL:
        this.soundSource = phonenewringtone;
        break;
      case RING_TYPES.CHAT:
        this.soundSource = chatRing;
        break;
      case RING_TYPES.MESSAGE:
        this.soundSource = digitalRing;
        break;
      case RING_TYPES.LOGOUT_ALARM:
        this.soundSource = dangRing;
        break;
      case RING_TYPES.CALLBACK:
        this.soundSource = digitalRing;
        break;
      case RING_TYPES.CASE:
        this.soundSource = ringbacknewtone;
        break;
      default:
        this.soundSource = ring;
        break;
    }
  }

  private createAudioElement(): HTMLAudioElement {
    const audio = new Audio(this.soundSource);
    audio.loop = this.loop;
    return audio;
  }

  play() {
    try {
      // Create new audio element if it doesn't exist
      if (!this.audio) {
        this.audio = this.createAudioElement();
      }

      this.audio.play();
    } catch (error) {
      console.error("Error playing audio:", error);
    }
  }

  pause() {
    try {
      if (this.audio) {
        this.audio.pause();
        this.audio.currentTime = 0;
        // Remove the audio element completely
        this.audio = null;
      }
    } catch (error) {
      console.error("Error pausing audio:", error);
    }
  }

  stop() {
    try {
      if (this.audio) {
        this.audio.pause();
        this.audio.currentTime = 0;
        // Remove the audio element completely
        this.audio = null;
      }
    } catch (error) {
      console.error("Error stopping audio:", error);
    }
  }

  setSource(source: string) {
    try {
      this.soundSource = source;
      // If audio is currently playing, stop it and it will be recreated on next play
      if (this.audio) {
        this.stop();
      }
    } catch (error) {
      console.error("Error setting audio source:", error);
    }
  }

  setOutputDevice(deviceId: string) {
    try {
      if (this.audio) {
        this.audio.setSinkId(deviceId);
      }
    } catch (error) {
      console.error("Error setting output device:", error);
    }
  }

  getType(): string {
    return this.type;
  }

  isLooping(): boolean {
    return this.loop;
  }
}

export default Player;
